import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AutomationRunStatus } from "entities/domain/automation-run";

export enum ActivePage {
  ACTIVITIES = "activities",
  SETTINGS = "settings",
}

export interface AttachmentsState {
  activePage: ActivePage;
  activeRunsFilter: "0" | "1"; // 0 - computed upcoming runs, 1 - past runs
  selectedRunStatuses: AutomationRunStatus[];
  selectedAutomationId: string | null;
  selectedCustomerId: number | null;
  selectedFromDate: string | null; // ISO string
  selectedToDate: string | null; // ISO string
}
const initialState: AttachmentsState = {
  activeRunsFilter: "0",
  activePage: ActivePage.SETTINGS,
  selectedRunStatuses: [],
  selectedCustomerId: null,
  selectedAutomationId: null,
  selectedFromDate: null,
  selectedToDate: null,
};

const automationsSlice = createSlice({
  name: "automations",
  initialState,
  reducers: {
    setActivePage(state, action: PayloadAction<ActivePage>) {
      state.activePage = action.payload;
    },
    setActiveRunsFilter: (state, action: PayloadAction<"0" | "1">) => {
      state.activeRunsFilter = action.payload;
    },
    setSelectedAutomationId: (state, action: PayloadAction<string | null>) => {
      state.selectedAutomationId = action.payload;
    },
    setSelectedRunStatuses: (
      state,
      action: PayloadAction<AutomationRunStatus[]>
    ) => {
      state.selectedRunStatuses = action.payload;
    },
    setSelectedCustomerId: (state, action: PayloadAction<number | null>) => {
      state.selectedCustomerId = action.payload;
    },
    setSelectedFromDate: (state, action: PayloadAction<string | null>) => {
      state.selectedFromDate = action.payload;
    },
    setSelectedToDate: (state, action: PayloadAction<string | null>) => {
      state.selectedToDate = action.payload;
    },
  },
});

export const {
  setActivePage,
  setSelectedRunStatuses,
  setSelectedCustomerId,
  setActiveRunsFilter,
  setSelectedAutomationId,
  setSelectedFromDate,
  setSelectedToDate,
} = automationsSlice.actions;
export const automationsSliceActions = automationsSlice.actions;
export default automationsSlice.reducer;
